export { parseCatalogProtocol } from './parseCatalogProtocol.ts';
